
import { removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export default function useCurrentPageDetails(state: ApplicationState) {
    const currentPage = getCurrentPage(state);
    const currentUrl = window.document.URL;
    
    const currentPageType = currentPage.type;
    
    let pageType = currentPageType;
        
    pageType = currentUrl.includes("search") ? 'Search Results' : currentUrl.includes("Checkout/Review") ? 'Order Review' : currentUrl.includes("brand") ? 'Brand Results': currentUrl.includes("Search") ? 'Search Results' : currentUrl.includes("Quote/Confirmation") ? 'Quote Confirmation' : pageType;
    if (currentPageType === "ProductDetailsPage")
    {
        pageType = "Product Details";
    } else if (currentPageType === "ProductListPage")
    {
        pageType = currentUrl.includes("Search?") ? 'Search Results' : 'Category Results';

    } else if (currentPageType === "BrandDetailsPage")
    {
        pageType = "Brand Details";
    } else if (currentPageType === "MyListsPage" || currentPageType === "MyListsDetailsPage")
    {
        pageType = "Wishlist";
    }    
        if (pageType)
    {
        setCookie("ProductSourceActionField", pageType);
    }
}
export  function removePageDetailsFromCookie() {
        removeCookie("ProductSourceActionField");
}